import { TextInput } from "@brexhq/component-library";
import * as React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { useFormSubmissionContext } from "@brexhq/next/src/components/modules/LeadForm/FormSubmissionProvider";
import { useLeadFormModuleContext } from "@brexhq/next/src/components/modules/LeadForm/LeadFormModuleProvider";
import { GTMFormPageTemplate } from "@brexhq/next/src/components/modules/LeadForm/Steps/PageTemplates/GTMFormPageTemplate";
import { LeadFormSteps } from "@brexhq/next/src/components/modules/LeadForm/machines/types";
import { LeadFormValues } from "@brexhq/next/src/components/modules/LeadForm/sharedTypes";

import { SingleFlexContainer } from "./elements";
export const GTMWebsite: React.FC = () => {
  const {
    submit,
    form: { getValues, fields },
  } = useFormSubmissionContext();

  const { customSubmitButtonLabel, customProgramName, customFormTitle } =
    useLeadFormModuleContext();

  /** Checks if fields are valid to disable */
  const validFields = !!getValues("website") && !fields.website.error;

  const onSubmit = React.useCallback(
    async (event) => {
      const fieldList: (keyof LeadFormValues)[] = ["website"];

      /**
       * Handles form submission including validations.
       * Reference FormSubmissionProvider.tsx for more context
       */
      submit({
        event,
        fields: fieldList,
        prevStep: LeadFormSteps.userInfo,
      });
    },
    [submit],
  );

  return (
    <GTMFormPageTemplate
      title={customFormTitle ?? "What’s your company website?"}
      step={LeadFormSteps.gtmWebsite}
      programName={customProgramName}
      nextAction={{
        label: customSubmitButtonLabel ?? "Continue",
        loading: false,
        disabled: !validFields,
        onClick: onSubmit,
      }}
    >
      <Container
        width="100%"
        display="flex"
        direction={{
          LRG: "row",
          SML: "column",
        }}
        margin={{
          LRG: [0, 0, "sml", 0],
          MED: [0, 0, "sml", 0],
          SML: [0, 0, "sml", 0],
        }}
        gap="sml"
      >
        <SingleFlexContainer>
          <Container display="flex" gap="sml" direction="column">
            <TextInput
              inputMode="text"
              size="large"
              autoComplete="family-name"
              disabled={getValues("hasNoWebsite")}
              {...fields.website}
              error={!validFields ? fields.website.error : null}
            />
          </Container>
        </SingleFlexContainer>
      </Container>
    </GTMFormPageTemplate>
  );
};
